import type { AnswersMap } from '@/features/jobs/questions/questions'

/**
 * Merges the answers to the currently asked questions over earlier answers.
 *
 * Answers to questions that are no longer asked are kept, so they come back
 * when a changed answer makes the question relevant again. Answers to
 * questions that are still asked are replaced, also when they were cleared.
 *
 * @param previous Earlier answers.
 * @param next Answers to the currently asked questions.
 * @param askedIds IDs of the currently asked questions.
 */
export function mergeAnswers(
  previous: AnswersMap,
  next: AnswersMap,
  askedIds: Iterable<string>,
): AnswersMap {
  const asked = new Set(askedIds)
  const result: AnswersMap = new Map(next)
  for (const [id, answer] of previous) {
    if (!result.has(id) && !asked.has(id)) {
      result.set(id, answer)
    }
  }
  return result
}
